module.exports = __webpack_public_path__ + "static/allmuslins-20d8df1dbc400d823e9f2958252ffa67.jpeg";